export const DOCS_URL = 'https://docs.graftcode.com'

export interface RuntimeGuide {
  id: string
  label: string
  /** gg --runtime token */
  command: string
  /** What --modules should point at for this language. */
  note: string
}

export const RUNTIME_GUIDES: RuntimeGuide[] = [
  {
    id: 'netcore',
    label: '.NET',
    command: 'gg --runtime netcore --modules ./bin/Release/net8.0/MyLibrary.dll',
    note: 'Point --modules at a .dll file (build/publish output) — directories are rejected for .NET. For .NET Framework use --runtime clr.',
  },
  {
    id: 'java',
    label: 'Java / JVM',
    command: 'gg --runtime java --modules ./target/myapp-1.0.0.jar',
    note: 'Point --modules at a .jar file — directories are rejected for Java, so package as a JAR first. (jvm is an alias for java.)',
  },
  {
    id: 'nodejs',
    label: 'Node.js',
    command: 'gg --runtime nodejs --modules ./my-node-package',
    note: 'Point --modules at the package folder (with package.json), its index.js entry, or package.json. Host your package folder, not node_modules.',
  },
  {
    id: 'python',
    label: 'Python',
    command: 'gg --runtime python --modules ./my-python-project',
    note: 'Point --modules at the project folder (with pyproject.toml), a single .py file, or a .whl/.zip. Dependencies must be installed in GG\u2019s Python environment.',
  },
  {
    id: 'ruby',
    label: 'Ruby',
    command: 'gg --runtime ruby --modules ./my-gem',
    note: 'Point --modules at the gem source folder (*.gemspec + lib/), a single .rb file, or a .zip. Dependencies must be installed in GG\u2019s Ruby environment.',
  },
  {
    id: 'php',
    label: 'PHP',
    command: 'gg --runtime php --modules ./my-php-app',
    note: 'Point --modules at the Composer project folder (composer.json), a single .php file, or a .phar/.zip.',
  },
]

export interface GatewayFlag {
  flag: string
  description: string
}

export const GATEWAY_FLAGS: GatewayFlag[] = [
  {
    flag: '--modules',
    description:
      'Comma-separated list of filesystem paths to load and host. Can also be passed as the first positional argument. If omitted, GG scans the top level of the current directory.',
  },
  {
    flag: '--runtime',
    description:
      'Runtime for the modules: auto (default), netcore, clr, java/jvm, python, python27, ruby, nodejs, php, or perl. All modules in one instance must share a runtime.',
  },
  {
    flag: '--port',
    description: 'TCP port the gateway listens on for client connections (for example 8888).',
  },
  {
    flag: '--httpPort',
    description: 'HTTP port the gateway exposes (for example 8889).',
  },
  {
    flag: '--types',
    description:
      'Filter which types GMA exposes from the loaded modules. Supports wildcards and comma-separated lists.',
  },
  {
    flag: '--methods',
    description:
      'Filter which methods GMA exposes from the loaded modules. Supports wildcards and comma-separated lists.',
  },
  {
    flag: '--runApp',
    description: 'Run the module\u2019s entry point after it is loaded (passed through to LoadLibrary).',
  },
  {
    flag: '--GMA',
    description: 'Enable GMA analysis of the same --modules paths.',
  },
  {
    flag: '--GV',
    description: 'Enable Vision — runs GMA analysis and serves the Vision UI (this is what you are looking at now).',
  },
]
